export const SMS_DISCLAIMER_TEXT_QUERY = `
query smsDisclaimerText ($disclaimerBaseParam: DisclaimerBaseParam!) {
  smsDisclaimerText(disclaimerBaseParam: $disclaimerBaseParam) {
    message
    status
      disclaimers {
        optinStatus
        disclaimerText {
          text
          url
        }
      }
    }
}
`

export const SMS_SUBMIT_NO_EMAIL_MUTATION = `mutation smsSubscriptionByPhoneNumber ($phoneCountryCode: String!, $phoneNumber: String!, $subscriptionBaseParam: SubscriptionBaseParam!) {
    smsSubscriptionByPhoneNumber (phoneCountryCode: $phoneCountryCode, phoneNumber: $phoneNumber, subscriptionBaseParam: $subscriptionBaseParam) {
      message
      status
    }
  }`
export const SMS_SUBMIT_WITH_EMAIL_MUTATION = `mutation smsSubscriptionByEmailAddress ($emailAddress: String!, $phoneCountryCode: String!, $phoneNumber: String!, $subscriptionBaseParam: SubscriptionBaseParam!) {
  smsSubscriptionByEmailAddress (emailAddress: $emailAddress, phoneCountryCode: $phoneCountryCode, phoneNumber: $phoneNumber, subscriptionBaseParam: $subscriptionBaseParam) {
    message
    status
  }
}`
